export const RESIDENCY_ROUTE_NAMES = {
  LIST: 'residencyList',
  DETAIL: 'residencyDetail',
}
